import { observer } from 'mobx-react-lite';
/* tslint:disable:jsx-no-lambda WI:47601 */
import * as React from 'react';
import { CalendarSearchRefiners } from '../index';
import getSearchProvider from 'owa-calendar-search-orchestration/lib/helpers/getSearchProvider';
import { SearchProvider } from 'owa-search-service';
import { SearchBox, SearchBoxContainerHandle } from 'owa-search';
import { SearchScenarioId } from 'owa-search-store';
import { getCalendarSearchStore } from 'owa-calendar-search-store';

export default observer(
    function CalendarSearchBoxContainer(props: {}, ref: React.Ref<SearchBoxContainerHandle>) {
        const searchBoxComponent = React.useRef<SearchBox>();
        /**
         * Publicly exposed function that allows parent to set focus inside of the
         * search input.
         */
        React.useImperativeHandle(
            ref,
            () => ({
                onSearchScopeSelected(searchScenarioId: SearchScenarioId) {
                    searchBoxComponent.current.onSearchScopeSelected(searchScenarioId);
                },
                setFocus() {
                    if (!searchBoxComponent.current) {
                        throw new Error(
                            'Cannot set focus on search box input when component ref is not initialized'
                        );
                    }
                    searchBoxComponent.current.focusSearchInput();
                },
            }),
            []
        );
        const setSearchBoxComponent = (ref: SearchBox) => {
            searchBoxComponent.current = ref;
        };
        const { searchBoxWidth } = getCalendarSearchStore();
        const isUsing3S = getSearchProvider() === SearchProvider.Substrate;
        return (
            <SearchBox
                isUsing3S={isUsing3S}
                ref={setSearchBoxComponent}
                renderRefiners={() => <CalendarSearchRefiners />}
                scenarioId={SearchScenarioId.Calendar}
                customCollapsedMaxWidth={searchBoxWidth}
            />
        );
    },
    { forwardRef: true }
);
